import React, { useContext, useEffect } from 'react'
import { toast } from 'react-toastify';
import { Button, Input, Spinner } from "@material-tailwind/react";
import { update_music, add_music_data } from '../../Controller/actions';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Switch from '../Switch/Switch';
import { NewContext } from '../../Context/NewContext';
import moment from 'moment';

export const MusicModal = () => {
    const { truncateString, setFormData, isModalLoading, multiCountry, setDeleteUpdateTag, deleteUpdateYes, handleSwitch, handleFileInput, setIsModalLoading, handleClose, handleChange, formData, open, addEditDeleteTag } = useContext(NewContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateSounds;
        setIsModalLoading(true);
        if (addEditDeleteTag === `update`) {
            let countryIdAry = multiCountry.map(_ele => _ele._id)
            createUpdateSounds = await update_music({ ...formData, country: countryIdAry || [], region: formData?.region || [] }, formData?._id)
        } else {
            createUpdateSounds = await add_music_data(formData)
        }
        setIsModalLoading(false);
        if (createUpdateSounds) {
            const { message, status } = createUpdateSounds;
            if (status) {
                toast.success(message);
                handleClose();
                setDeleteUpdateTag(deleteUpdateYes);
            } else {
                toast.error(message);
            };
        }
    }

    useEffect(() => {
        if (addEditDeleteTag === `add`) setFormData({ ...formData, isActive: true, isPremium: false })
    }, [addEditDeleteTag]);
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "625px",
                            borderRadius: "12px" // Set your width here
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit Music` : `Add  Music`
                    }
                </DialogTitle>
                <DialogContent>
                    {
                        addEditDeleteTag === 'update' ? <div className="">
                            <label className="block text-sm font-medium leading-6 text-gray-900">Last update : {moment(formData?.updatedAt).format('DD/MM/YYYY,hh:mm A')}</label>
                        </div> : null
                    }
                    <div>
                        {
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form">
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900"> <p>Name <sup className='text-red-600'>*</sup> :</p> </label>
                                        <div className="mt-2">
                                            <Input id='name' placeholder='Enter Name' name='name' onChange={handleChange} value={formData?.name} autoComplete='false' required />
                                        </div>
                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="mp3file" className="block text-sm font-medium leading-6 text-gray-900"><p>Mp3 File <sup className='text-red-600'>*</sup> :</p> </label>
                                        <div className="mt-1.5 relative">
                                            {
                                                addEditDeleteTag === `update` ? <input id='mp3file' type='file' name='mp3file' accept='audio/*' onChange={handleFileInput} className=' w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' /> :
                                                    <input id='mp3file' type='file' name='mp3file' accept='audio/*' onChange={handleFileInput} className=' w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' required />
                                            }
                                            {
                                                addEditDeleteTag === `update` && formData.mp3file && typeof formData.mp3file === 'string' &&
                                                <label htmlFor="bigPreviewStickerStore" className='absolute sm:left-[37%] left-[33.5%] right-[2px] w-auto rounded-r-[7px] border-1 border-white text-sm leading-none bg-white h-[90%] top-0 bottom-0 m-auto flex items-center pl-1'>{truncateString(formData.mp3file.split('/').pop(), 10)}</label>
                                            }
                                        </div>
                                    </div>

                                    <div className="col-span-2 sm:col-span-1">
                                        <label htmlFor="isPremium" className="block text-sm font-medium leading-6 text-gray-900">Premium:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isPremium' name='isPremium' onChange={handleSwitch} checked={formData?.isPremium} />
                                        </div>
                                    </div>

                                    <div className="col-span-2 sm:col-span-2">
                                        <label htmlFor="isActive" className="block text-sm font-medium leading-6 text-gray-900">Active:</label>
                                        <div className="mt-1.5">
                                            <Switch color='green' id='isActive' name='isActive' onChange={handleSwitch} checked={formData?.isActive} />
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end mt-5'>
                                    <Button
                                        onClick={handleClose}
                                        className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                    >
                                        <span>Cancel</span>
                                    </Button>
                                    <Button
                                        disabled={isModalLoading}
                                        className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                        type='submit'
                                    >
                                        {isModalLoading && <Spinner className="h-4 w-4" />}
                                        <span className={isModalLoading ? 'ml-4' : ''}>{addEditDeleteTag === `update` ? `Update` : `Add`}</span>
                                    </Button>
                                </div>
                            </form>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default MusicModal
